export const getTempUrl = (file: File): string => URL.createObjectURL(file);

export const clearTempUrl = (url?: string): void => {
  if (!!url) URL.revokeObjectURL(url);
};
